import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["component", "isActive", "isDisabled", "isHover", "isFocus", "useBrowserDefaultFocusStyle", "sentenceCase"];
import React from 'react';
import { cssColorValue, cssSpacing, durationMedium, opacityActive, opacityDisabled, semanticColors } from "../../styles/index.mjs";
import { TagElement } from "../Tag/Tag.mjs";
import styled, { css } from "../../styled-components.mjs";
var transitionColor = durationMedium;
var transitionBg = '0.3s';
var NavBarListItemLink = /*#__PURE__*/React.forwardRef(function NavBarListItemLink(_ref, ref) {
  var Component = _ref.component,
    isActive = _ref.isActive,
    isDisabled = _ref.isDisabled,
    isHover = _ref.isHover,
    isFocus = _ref.isFocus,
    useBrowserDefaultFocusStyle = _ref.useBrowserDefaultFocusStyle,
    sentenceCase = _ref.sentenceCase,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Component, Object.assign({
    ref: ref
  }, rest));
});
NavBarListItemLink.displayName = 'NavBarListItemLink';
export var Link = styled(NavBarListItemLink).withConfig({
  displayName: "Link",
  componentId: "sc-1g2blu2-0"
})(["border:0;display:inline-block;padding-block:", " 10px;padding-inline:", ";text-decoration:none;transition:", " color linear;color:", ";", ";", ";", ";", ";li:first-child > &{margin-inline-start:0;padding-inline-start:0;}li:last-child > &{margin-inline-end:0;padding-inline-end:0;}", " &::after{background-color:transparent;content:'';display:block;block-size:2px;margin-block:0 calc(-1 * ", ");margin-inline:auto;position:relative;top:8px;transition:background-color ", ";inline-size:", ";", " ", ";}", "{margin-block:calc(-1 * ", ") calc(-1 * ", ");}"], cssSpacing('tighter', '12px'), cssSpacing('base', '16px'), transitionColor, cssColorValue(semanticColors.textSubdued), function (props) {
  return !props.isActive && !props.isDisabled && css(["&:hover{color:", ";}&:active{opacity:", ";}"], cssColorValue(semanticColors.textBase), opacityActive);
}, function (props) {
  return (props.isActive || props.isHover) && css(["color:", ";"], cssColorValue(semanticColors.textBase));
}, function (props) {
  return props.isFocus && props.sentenceCase && css(["color:", ";"], cssColorValue(semanticColors.textBase));
}, function (props) {
  return props.isDisabled && css(["opacity:", ";cursor:not-allowed;pointer-events:none;"], opacityDisabled);
}, function (props) {
  return !props.useBrowserDefaultFocusStyle && css(["&[href]:focus{outline:none;", ";&::after{background-color:", ";inline-size:100%;}}"], props.sentenceCase && css(["color:", ";"], cssColorValue(semanticColors.textBase)), cssColorValue(semanticColors.essentialBase));
}, cssSpacing('tighter-5', '2px'), transitionBg, function (props) {
  return props.sentenceCase ? '16px' : '30px';
}, function (props) {
  return props.isFocus && css(["background-color:", ";inline-size:100%;"], cssColorValue(semanticColors.essentialBase));
}, function (props) {
  return props.isActive && css(["background-color:", ";"], props.sentenceCase ? cssColorValue(semanticColors.essentialBase) : cssColorValue(semanticColors.essentialBrightAccent));
}, TagElement, cssSpacing('tighter-4', '4px'), cssSpacing('tighter-4', '4px'));